import { CellProps } from 'react-table'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { sortableColumn, StackedCell, TableColumn } from '../../../../../../components'
import { FaturaProfissionalList } from '../../core/_models'
import { ProtocoloAtendimentoCell } from '../../../faturas-atendimentos-list/table/columns/ProtocoloAtendimentoCell'
import { TFunction } from '_metronic/i18n/Metronici18n'

export const faturaProfissionalAtendimentosColumns = (
  t: TFunction
): ReadonlyArray<TableColumn<FaturaProfissionalList>> => [
  // Protocolo (abre o detalhe do atendimento) com a especialidade como apoio.
  sortableColumn<FaturaProfissionalList>({
    id: 'atendimento.protocolo',
    useQueryRequest,
    fields: [{ field: 'atendimento.protocolo', label: t('cols.protocolo') }],
    Cell: ({ row }: CellProps<FaturaProfissionalList>) => (
      <ProtocoloAtendimentoCell atendimento={row.original.atendimento} isResponsavel />
    ),
  }),
  sortableColumn<FaturaProfissionalList>({
    id: 'valorProfissional',
    cellWidth: '168px',
    align: 'end',
    useQueryRequest,
    fields: [{ field: 'valorProfissional', label: t('cols.valor_receber') }],
    Cell: ({ row }: CellProps<FaturaProfissionalList>) => (
      <StackedCell tabular primary={row.original.valorProfissionalFormatado} />
    ),
  }),
]
